import * as React from 'react'
import { css } from '@emotion/react'
import { TableCell, TableRow } from '../../atoms/Table'
import { CompanyData } from '../../../types/api'
import { isPrivate, isIPO } from '@/lib/company'
import { FormattedDate } from '../../atoms/FormattedDate'
import { FormattedNumber } from '../../atoms/FormattedNumber'
import { CompanySummaryCell } from './internal/CompanySummaryCell'

export const CompaniesTableBody: React.FC<{
  items: CompanyData[]
  withTotalFunding: boolean
}> = ({ items, withTotalFunding: totalFunding }) => {
  return (
    <tbody>
      {items.map((company, i) => {
        return (
          <TableRow highlightOnHover key={i} className="row">
            <CompanySummaryCell
              company={company}
              css={css`
                width: ${totalFunding ? '50%' : '60%'};
              `}
            />
            <TableCell nowrap centerized>
              <FormattedDate>{company.establishedAt}</FormattedDate>
            </TableCell>
            <TableCell nowrap centerized className="last-funding-date">
              <FormattedDate>{company.latestFundraise?.date}</FormattedDate>
            </TableCell>
            <TableCell centerized>
              {isPrivate(company) && company.latestInitialSeries}
            </TableCell>
            {totalFunding && (
              <TableCell
                vertical="middle"
                align="right"
                className="total-fundraise"
              >
                {company.totalFundraise && company.totalFundraise !== 0 ? (
                  <FormattedNumber
                    sub={company.hasEstimatedRound ? '（推測）' : ''}
                  >
                    {company.totalFundraise && company.totalFundraise}
                  </FormattedNumber>
                ) : (
                  ''
                )}
              </TableCell>
            )}
            <TableCell vertical="middle" align="right">
              <FormattedNumber
                sub={
                  isIPO(company)
                    ? 'IPO前最終調達時'
                    : company.hasEstimatedRound
                      ? '（推測）'
                      : ''
                }
              >
                {company.valuation}
              </FormattedNumber>
            </TableCell>
          </TableRow>
        )
      })}
    </tbody>
  )
}
